// Specializaion
import { subGroup, route, meta } from '@/helpers/routes'
import Index from './index/index'

const routes = [
  route('index', '/index', Index, meta('Termo de uso', true, 'guest'))
]

export default subGroup('/patient/terms', routes)



// WEBPACK FOOTER //
// ./src/app/patient/terms/routes.js